import LocaleStrings from "Languages";
import _ from "lodash";

// Pre defaind page optimize [Note:custom option will toggle custom input fileds W(cm) & H(cm) ]
const PAGESIZEOPTIONS = [
  { name: "A4 - US Letter", value: "21.0#29.7" }, // w * h
  { name: "A5 - US Letter", value: "14.8#21.0" }, // w * h
  { name: "A6 - US Letter", value: "10.5#14.8" }, // w * h
  { name: LocaleStrings.custom, value: "custom" }, // custom
];

const PAGEDEFAULTSIZE = PAGESIZEOPTIONS[0].value; // PAGESIZEOPTIONS default size

const PAGEDEFAULTPADDING = "2.54#0#0#0.64";

// Pre badge size [Note:custom option will toggle custom input fileds W(cm) & H(cm) ]
const BADGESIZEOPTIONS = [
  { name: `Badge 1`, value: "8.89#4.44" },
  { name: `Badge 2`, value: "8.38#5.20" },
  { name: `Badge 3`, value: "8.57#5.39" },
  { name: `Badge 4`, value: "9.85#6.68" },
  { name: LocaleStrings.custom, value: "custom" }, // custom
];

const BADGEDEFAULTSIZE = BADGESIZEOPTIONS[0].value; // BADGESIZEOPTIONS default size
const BADGEMINWIDTH = 1; // Badge min width
const BADGEMAXWIDTH = 100; // Badge max width
const BADGEMINHEIGHT = 1; // Badge min height
const BADGEMAXHEIGHT = 100; // Badge max height

const FONTSIZEOPTIONS = [
  { id: 12, label: "12px", value: "12px" },
  { id: 14, label: "14px", value: "14px" },
  { id: 16, label: "16px", value: "16px" },
  { id: 18, label: "18px", value: "18px" },
  { id: 20, label: "20px", value: "20px" },
  { id: 22, label: "22px", value: "22px" },
  { id: 24, label: "24px", value: "24px" },
  { id: 26, label: "26px", value: "26px" },
  { id: 28, label: "28px", value: "28px" },
  { id: 30, label: "30px", value: "30px" },
  { id: 32, label: "32px", value: "32px" },
  { id: 34, label: "34px", value: "34px" },
  { id: 36, label: "36px", value: "36px" },
  { id: 38, label: "38px", value: "38px" },
  { id: 40, label: "40px", value: "40px" },
  { id: 42, label: "42px", value: "42px" },
  { id: 44, label: "44px", value: "44px" },
  { id: 46, label: "46px", value: "46px" },
  { id: 48, label: "48px", value: "48px" },
  { id: 50, label: "50px", value: "50px" },
  { id: 52, label: "52px", value: "52px" },
  { id: 54, label: "54px", value: "54px" },
  { id: 56, label: "56px", value: "56px" },
  { id: 58, label: "58px", value: "58px" },
  { id: 60, label: "60px", value: "60px" },
  { id: 62, label: "62px", value: "62px" },
  { id: 64, label: "64px", value: "64px" },
  { id: 66, label: "66px", value: "66px" },
  { id: 68, label: "68px", value: "68px" },
  { id: 70, label: "70px", value: "70px" },
  { id: 72, label: "72px", value: "72px" },
  { id: 74, label: "74px", value: "74px" },
  { id: 76, label: "76px", value: "76px" },
  { id: 78, label: "78px", value: "78px" },
  { id: 80, label: "80px", value: "80px" },
  { id: 82, label: "82px", value: "82px" },
  { id: 84, label: "84px", value: "84px" },
  { id: 86, label: "86px", value: "86px" },
  { id: 88, label: "88px", value: "88px" },
  { id: 90, label: "90px", value: "90px" },
  { id: 92, label: "92px", value: "92px" },
  { id: 94, label: "94px", value: "94px" },
  { id: 96, label: "96px", value: "96px" },
  { id: 98, label: "98px", value: "98px" },
  { id: 100, label: "100px", value: "100px" },
];

const DEFAULTFONTSIZE = "12px";

const FONTFAMILYOPTIONS = [
  { id: 1, label: "Helvetica", value: "Helvetica" },
  { id: 2, label: "Times New Roman", value: "Times New Roman" },
  { id: 2, label: "Poppins", value: "Poppins" },
  // { id: 3, label: "Courier New", value: "Courier New" },
  // { id: 4, label: "Georgia", value: "Georgia" },
  // { id: 5, label: "Arial", value: "Arial" },
  // { id: 6, label: "Arial Black", value: "Arial Black" },
  // { id: 7, label: "Impact", value: "Impact" },
  // { id: 8, label: "Lucida Sans Unicode", value: "Lucida Sans Unicode" },
  // { id: 9, label: "Tahoma", value: "Tahoma" },
  // { id: 10, label: "Verdana", value: "Verdana" },
  // { id: 11, label: "Lucida Console", value: "Lucida Console" },
  // { id: 12, label: "serif", value: "serif" },
  // { id: 13, label: "sans-serif", value: "sans-serif" },
  // { id: 14, label: "cursive", value: "cursive" },
  // { id: 15, label: "fantasy", value: "fantasy" },
  // { id: 16, label: "monospace", value: "monospace" },
];

const DEFAULTFONTFAMILY = "Helvetica";

// Not is use
const FONTWEIGHTOPTIONS = [
  { id: 1, label: "Normal", value: "normal" },
  { id: 2, label: "Bold", value: "bold" },
  { id: 3, label: "Lighter", value: "lighter" },
  { id: 4, label: "Bolder", value: "bolder" },
  { id: 5, label: "100", value: "100" },
  { id: 6, label: "900", value: "900" },
];
// Not is use
const DEFAULTFONTWEIGHT = "normal";

export {
  PAGESIZEOPTIONS,
  PAGEDEFAULTSIZE,
  PAGEDEFAULTPADDING,
  BADGESIZEOPTIONS,
  BADGEDEFAULTSIZE,
  BADGEMINWIDTH,
  BADGEMAXWIDTH,
  BADGEMINHEIGHT,
  BADGEMAXHEIGHT,
  FONTSIZEOPTIONS,
  DEFAULTFONTSIZE,
  FONTFAMILYOPTIONS,
  DEFAULTFONTFAMILY,
  FONTWEIGHTOPTIONS,
  DEFAULTFONTWEIGHT,
};
